export default {
  REQUIRED: "This field is required",
  INVALID_URL: "Invalid Url",
  INVALID_EMAIL: "Invalid email address",
  ATLEAST_ONE_URL_REQUIRED: "At least one url should be added"
}